import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import useFetch from 'use-http';
import { Loader2 } from 'lucide-react';

const OrderToServicesRedirect = () => {
  const history = useHistory();
  const { workplaceId, serviceId } = useParams();

  const { get, response } = useFetch('/Services');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const run = async () => {
      if (!workplaceId || !serviceId) {
        history.replace('/');
        return;
      }

      const s = await get(`WorkplaceServices/${workplaceId}/${serviceId}`);

      if (!response?.ok || !s || s.errors) {
        history.replace('/');
        return;
      }

      const params = new URLSearchParams();
      params.set('serviceId', s.serviceId);
      params.set('departmentId', s.departmentId);
      if (s.specialistId) params.set('specialistId', s.specialistId);
      if (s.cityId) params.set('cityId', s.cityId);

      history.replace(
        `/services/${s.categoryId}/${s.serviceTypeId}?${params.toString()}`,
      );
    };

    run();
  }, [workplaceId, serviceId, get, response, history]);

  if (!loading) return null;

  return (
    <div className="flex items-center justify-center min-h-[50vh]">
      <div className="flex items-center justify-center gap-2">
        <Loader2 className="h-5 w-5 animate-spin text-muted-foreground" />
        <span>Kraunama...</span>
      </div>
    </div>
  );
};

export default OrderToServicesRedirect;
